import React from 'react'
import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { ReactComponent as BadgeWarningSVG } from 'src/components/Icons/Basic/icons_badge_warning.svg'

const CardContainer = styled.div`
  background: ${palette.neutral[30]};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  width: 100%;
  flex: 1;
  min-height: 400px;
`

const IconCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fff8e1;
  border: 1px solid #fedf89;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 28px;
    height: 26px;
  }
`

const Title = styled.h2`
  font-family: Poppins, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: ${palette.neutral[900]};
  margin: 16px 0 8px 0;
  text-align: center;
`

const Message = styled.p`
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${palette.neutral[600]};
  margin: 0;
  text-align: center;
  max-width: 460px;
`

export const AccessRestricted = (): JSX.Element => {
  return (
    <CardContainer data-testid="access-restricted-card">
      <IconCircle>
        <BadgeWarningSVG />
      </IconCircle>
      <Title>Access Restricted</Title>
      <Message>
        You don&#39;t have permission to view this content. Contact your
        administrator for access.
      </Message>
    </CardContainer>
  )
}
